import { Button, Tooltip } from "@mui/material";
import theme from "@/theme";
const PostButton = ({
  postVariant,
  invalidCashtags,
  postText,
  isUrl,
  imagePreviews,
}: {
  postVariant: string;
  invalidCashtags: string[];
  selectedChip: string[];
  postText: string;
  isUrl: boolean;
  imagePreviews: string[];
}) => {
  const commonButtonProps = {
    type: "submit" as const,
    variant: "contained" as const,
    color: "primary" as const,
    sx: {
      borderRadius: "20px",
      bgcolor: theme.palette.custom.mainBlue,
      textTransform: "none",
      "&:hover": { bgcolor: "#0D8BD0" },
      "&:disabled": {
        bgcolor: theme.palette.custom.mainBlueDisable,
        color: "#fff",
      },
    },
  };

  let disabled = false;
  const hasCashtag = /\$[a-zA-Z0-9_]+/.test(postText);
  const hasLink = /https?:\/\/\S+/.test(postText);
  const hasImage = imagePreviews.length > 0;

  // Invalid cashtags block posting for every post type, not just Stocks.
  if (invalidCashtags.length > 0) {
    return (
      <Tooltip
        title={`Invalid cashtag${invalidCashtags.length > 1 ? "s" : ""}: ${invalidCashtags.join(" ")}`}
        arrow
        placement="top"
      >
        <span>
          <Button {...commonButtonProps} disabled>
            Post
          </Button>
        </span>
      </Tooltip>
    );
  }

  if (postVariant === "Stocks") {
    disabled = !postText.trim() || !hasCashtag || !(hasLink || hasImage);
  }

  if (postVariant === "Economics") {
    disabled = !postText.trim() || (!isUrl && imagePreviews.length === 0);
  }
  if (postVariant === "Personal") {
    disabled = !postText.trim();
  }

  if (postVariant === "Economics") {
    const hasLink = /https?:\/\/\S+/.test(postText);
    const hasImage = imagePreviews.length > 0;
    disabled = !(hasLink || hasImage);
  }

  return (
    <Button {...commonButtonProps} disabled={disabled}>
      Post
    </Button>
  );
};

export default PostButton;
